import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Host, HostBinding, Inject, Input, OnDestroy, OnInit, Optional, Output } from '@angular/core';
import { App } from '@df/core/app';
import { OffClickDirective } from '@df/module-off-click/off-click.directive';
import { OnChange } from '@df/ng/on-change';
import { BodyClassService } from '@df/ui/body-class.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ProductViewSidebarComponent } from '../../../catalog/ui/product/view/sidebar/product-view-sidebar.component';

@Component({
    selector: 'page-sidebar',
    templateUrl: './page-sidebar.component.html',
    styleUrl: './page-sidebar.component.scss',
    standalone: true,
    imports: [CommonModule, OffClickDirective, TranslatePipe]
})
export class PageSidebarComponent extends UiComponent implements OnInit, OnDestroy {
    @Input()
    backArrow = false;

    @Input()
    closeButton = false;

    @Input()
    @HostBinding('class.is-open')
    @OnChange(function () {
        const that = this as PageSidebarComponent;
        this.bodyClassService.set('main-overlay-visible', that, !!that.isOpen);

        if (this.initiated) {
            that.repaintFix();
        }

        this.isOpenChange?.next(this.isOpen);
    })
    isOpen = false;

    @Output()
    isOpenChange = new EventEmitter<boolean>();

    @Output()
    closeRequest = new EventEmitter<void>();

    protected override canDetach = false;

    constructor(
        private bodyClassService: BodyClassService,
        readonly app: App,
        @Inject(DOCUMENT) protected docRef: Document,
        @Optional() @Host() private productViewSidebar: ProductViewSidebarComponent
    ) {
        super();
    }

    override ngOnInit(): void {
        this.subscriptions.add(
            this.app.events.on('pageSidebar.close').subscribe(() => {
                this.close();
            })
        );

        super.ngOnInit();
    }

    override ngOnDestroy(): void {
        this.bodyClassService.remove('main-overlay-visible', this);

        super.ngOnDestroy();
    }

    requestClose(): void {
        if (this.productViewSidebar) {
            this.closeRequest.emit();
        } else {
            this.close();
        }
    }

    close(): void {
        this.isOpen = false;

        this.detectChanges();
    }

    protected repaintFix() {
        if (this.app.isPlatformBrowser) {
            const button = this.docRef.querySelector('add-to-basket') as HTMLElement;

            if (button && this.initiated) {
                this.timeoutService.setTimeout(() => {
                    button.style.transform = !this.isOpen ? 'scale(1)' : null; // trigger CSS repaint
                }, 375);

                this.timeoutService.setTimeout(() => {
                    button.style.transform = null;
                }, 750);
            }
        }
    }
}
